import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { actions as toastrActions } from 'react-redux-toastr';
import { useIdleTimer } from 'react-idle-timer';
import useLogoutPrompt from '../../../hooks/useLogoutPrompt';
import authService from '../../../services/auth';
import './LogoutOnInactivity.scss';

const defaultTimeout = 1000 * 60 * 10;
const timeBeforeIdle = Number(process.env.REACT_APP_TIME_BEFORE_IDLE) || defaultTimeout;

/**
 * Signs out after inactivity, unless the shared session is still in use by another tab or another Zaddons product.
 * @param {{ onLogOut: () => void }} param0
 */
const LogoutOnInactivity = ({ onLogOut }) => {
    const dispatch = useDispatch();
    const lastActivityAt = useRef(Date.now());
    /** @type {import('react').MutableRefObject<import('react-idle-timer').IIdleTimer | null>} */
    const idleTimer = useRef(null);

    const signOutUnlessActiveElsewhere = async () => {
        if (await authService.isSessionActiveElsewhere(lastActivityAt.current)) {
            dispatch(toastrActions.hideConfirm());
            idleTimer.current?.reset();
            return;
        }
        onLogOut();
    };

    const onPromptLogout = useLogoutPrompt(signOutUnlessActiveElsewhere);

    idleTimer.current = useIdleTimer({
        timeout: timeBeforeIdle,
        onIdle: onPromptLogout,
        onAction: () => {
            lastActivityAt.current = authService.markActivity();
        },
        throttle: 1000,
    });

    return (
        <>
        </>
    );
};

export default LogoutOnInactivity;
